import constants from 'constants';

const {SET_ZOOM_ACCOUNTS} = constants;
const initialState = {
  zoomAccounts: [],
};

export const zoom = (state = initialState, action) => {
  const {type, payload} = action || {};
  const {zoomAccounts} = payload || {};

  switch (type) {
    case SET_ZOOM_ACCOUNTS:
      return {
        ...state,
        zoomAccounts,
      };
    default:
      return state;
  };
};



// WEBPACK FOOTER //
// ./src/reducers/zoom.js